import { pointsMinCcv } from 'root/src/shared/constants/points';
import { isDevEnv } from 'root/src/shared/util/envSelect';
export const getCanEarnPoints = (params) => {
    var _a;
    const creatorIsPartner = isDevEnv || params.isPartner;
    return (((_a = params.dropEvent) === null || _a === void 0 ? void 0 : _a.awardPoints)
        && params.ccv >= pointsMinCcv
        && params.isAbleToParticipate
        && creatorIsPartner)
        || params.isCreatorPointsAllowlisted;
};
